import type { XmlItemRating } from "../../../shared/analysis-types";

export type ScorecardRatingBadgeVariant =
  | "exceeds"
  | "great"
  | "meets"
  | "needs-work"
  | "needs-improvement"
  | "unknown";

export interface ScorecardRatingDisplay {
  label: string;
  badgeVariant: ScorecardRatingBadgeVariant;
  copyStyle: {
    badgeBackground: string;
    badgeColor: string;
    rowBackground: string;
    badgeBorder?: string;
  };
}

export const scorecardRatingDisplay: Record<XmlItemRating, ScorecardRatingDisplay> = {
  exceeds: {
    label: "Exceeds",
    badgeVariant: "exceeds",
    copyStyle: {
      badgeBackground: "#166534",
      badgeColor: "#DCFCE7",
      rowBackground: "#F0FDF4",
    },
  },
  great: {
    label: "Great",
    badgeVariant: "great",
    copyStyle: {
      badgeBackground: "#DCFCE7",
      badgeColor: "#166534",
      rowBackground: "#F0FDF4",
    },
  },
  meets: {
    label: "Meets",
    badgeVariant: "meets",
    copyStyle: {
      badgeBackground: "#FEF9C3",
      badgeColor: "#CA8A04",
      rowBackground: "#FFFFFF",
    },
  },
  not_yet: {
    label: "Not Yet",
    badgeVariant: "needs-work",
    copyStyle: {
      badgeBackground: "#FFEDD5",
      badgeColor: "#EA580C",
      rowBackground: "#FFF7ED",
    },
  },
  needs_improvement: {
    label: "Improve",
    badgeVariant: "needs-improvement",
    copyStyle: {
      badgeBackground: "#FEE2E2",
      badgeColor: "#DC2626",
      rowBackground: "#FEF2F2",
    },
  },
  na: {
    label: "N/A",
    badgeVariant: "unknown",
    copyStyle: {
      badgeBackground: "#F7F5F2",
      badgeColor: "#7A7266",
      rowBackground: "#FFFFFF",
    },
  },
  unknown: {
    label: "Unknown",
    badgeVariant: "unknown",
    copyStyle: {
      badgeBackground: "#FEE2E2",
      badgeBorder: "2px dashed #DC2626",
      badgeColor: "#DC2626",
      rowBackground: "#FEF2F2",
    },
  },
};

const sessionActionCategoryLabels: Record<string, string> = {
  topics: "Topics & Education",
  recommendations: "Recommendations",
  supplements: "Supplements",
  goals: "Goals",
  clinical_decisions: "Clinical Decisions",
  plan: "Plan",
};

export function getSessionActionCategoryLabel(category: string): string {
  return sessionActionCategoryLabels[category] ?? category.replace(/_/g, " ");
}
